// لون تعبئة الإطار الدائري لكل اختصار (نفس أسلوب بطاقة اليوم).
const TILES = {
  myLog: "bg-sky-500",
  myPayslip: "bg-amber-500",
  myPerformance: "bg-indigo-500",
  myRequests: "bg-violet-600",
  tasks: "bg-violet-600",
  resignation: "bg-red-500",
  myBonuses: "bg-emerald-500",
  bonuses: "bg-emerald-500",
  penalties: "bg-red-500",
  kpi: "bg-indigo-500",
  employees: "bg-fuchsia-500",
  documents: "bg-orange-500",
  requests: "bg-cyan-500",
  accounting: "bg-emerald-600",
  sales: "bg-teal-500",
  duties: "bg-rose-500",
  branches: "bg-indigo-600",
  liveMap: "bg-cyan-600",
  reports: "bg-blue-500",
  wallet: "bg-yellow-500",
  payroll: "bg-lime-600",
  api: "bg-slate-500",
  backup: "bg-emerald-600",
  billing: "bg-pink-500",
  settings: "bg-zinc-500",
};

export const tileIconColor = (key) => TILES[key] || "bg-primary";
